import React from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Grid } from 'react-md'

import { handleSubmit, Input } from 'components/form'
import { Modal } from 'components/core'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

interface ComponentProps {
  maintenanceScheduleId: string
  visibleModal: boolean
  disableModal: () => void
  loadMaintenanceSchedule: () => Promise<void>
}

const Component: React.FC<ComponentProps> = ({ maintenanceScheduleId, visibleModal, disableModal, loadMaintenanceSchedule }) => {
  const form = useForm({ defaultValues })

  return (
    <Modal
      title={'Criação de Item de Inspeção'}
      visible={visibleModal}
      confirmTitle={'Salvar'}
      confirmDisabled={!form.formState.dirty}
      confirmAction={async () => {
        await handleSubmit(form, validationSchema, async () => {
          await handleSave({ maintenanceScheduleId, ...form.getValues() })
          form.reset(defaultValues, { dirty: false })
          await loadMaintenanceSchedule()
          disableModal()
        })
      }}
      closeTitle={'Fechar'}
      closeAction={async () => {
        form.reset(defaultValues, { dirty: false })
        disableModal()
      }}>
      <Grid>
        <FormContext {...form}>
          <Input name='description' label='Descrição *' desktopSize={9} tabletSize={6} />
          <Input name='format' label='Formato *' desktopSize={3} tabletSize={2} />
        </FormContext>
      </Grid>
    </Modal>
  )
}

export default Component
